/* Sedr reviews: share one filtered observer across the asset and shop metafield. */
(function () {
  if (window.sedrReviewsObserve) return;
  var selector = '[class^="jm-"],[class*=" jm-"],[class^="jdgm-"],[class*=" jdgm-"],.sedr-hist,.sedr-ai,.sedr-snip,.product-card .rating';
  var jobs = [], now = [], timer = null;
  function within(node) {
    var el = node && (node.nodeType === 1 ? node : node.parentElement);
    return !!(el && el.closest && el.closest(selector));
  }
  function contains(node) {
    return !!(node && node.nodeType === 1 &&
      (node.matches(selector) || node.querySelector(selector)));
  }
  function relevant(records) {
    for (var i = 0; i < records.length; i++) {
      var record = records[i];
      if (within(record.target)) return true;
      for (var j = 0; j < record.addedNodes.length; j++) if (contains(record.addedNodes[j])) return true;
      for (var k = 0; k < record.removedNodes.length; k++) if (contains(record.removedNodes[k])) return true;
    }
    return false;
  }
  function flush() {
    timer = null;
    for (var i = 0; i < jobs.length; i++) {
      try { jobs[i](); } catch (error) { console.error('Sedr review enhancement:', error); }
    }
  }
  function queue() {
    if (timer === null) timer = setTimeout(flush, 100);
  }
  var observer = new MutationObserver(function (records) {
    if (!relevant(records)) return;
    for (var i = 0; i < now.length; i++) {
      try { now[i](); } catch (error) { console.error('Sedr review enhancement:', error); }
    }
    queue();
  });
  observer.observe(document.documentElement, {
    childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['aria-selected']
  });
  /* immediate: the job also runs in the observer callback, before the next paint */
  window.sedrReviewsObserve = function (job, immediate) {
    if (jobs.indexOf(job) === -1) jobs.push(job);
    if (immediate && now.indexOf(job) === -1) now.push(job);
  };
  window.sedrReviewsObserve.immediate = true;
  document.addEventListener('shopify:section:load', queue);
  window.addEventListener('pageshow', function (event) { if (event.persisted) queue(); });
})();
(function () {
if (window.sedrReviewsMetafieldLoaded) return;
window.sedrReviewsMetafieldLoaded = true;
window.sedrRevAI=null;(function(){var AR=/[؀-ۿ]/,ONE=null,P='<path d="M7.5 0L9.58587 5.2731L15 5.72949L10.875 9.44483L12.1353 15L7.5 12.0231L2.86475 15L4.125 9.44483L0 5.72949L5.41414 5.2731L7.5 0Z" fill="currentColor"></path>';
function stars(n){var s='';for(var i=0;i<5;i++)s+=i<n?'★':'☆';return s;}
function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
function tr(){var b=document.querySelectorAll('.jdgm-translate-button:not([data-sedr-t])');for(var i=0;i<b.length;i++){var btn=b[i];btn.setAttribute('data-sedr-t','1');var card=btn.closest('.jm-review-item,.jdgm-carousel-item,.jdgm-rev,[class*=lightbox],.jdgm-modal');var body=card&&card.querySelector('.jm-review-content__body,.jdgm-rev__body,[class*=body]');if(body&&AR.test(body.textContent)){var box=btn.closest('.jdgm-translate-container')||btn.parentElement;if(box)box.classList.add('sedr-hide');}if(/undefined/i.test(btn.textContent))btn.textContent=btn.textContent.replace(/\s*\(?\s*undefined\s*\)?/ig,'');}}
function counts(){var H=window.sedrRevHist;if(!H)return;var t=document.querySelectorAll('.jm-rating-filter__tag:not([data-v3])');for(var i=0;i<t.length;i++){var r=parseInt(t[i].textContent,10);t[i].setAttribute('data-v3','1');for(var j=0;j<H.length;j++){if(H[j].rating===r){var sp=document.createElement('span');sp.className='sedr-cnt';sp.textContent='('+H[j].frequency+')';var inp=t[i].querySelector('input');t[i].insertBefore(sp,inp);}}}}
function vbadge(){var vb=document.querySelectorAll('.jm-verified-badge:not([data-v3]),.jm-verified-buyer-badge:not([data-v3])');for(var k=0;k<vb.length;k++){vb[k].setAttribute('data-v3','1');var tx=vb[k].querySelectorAll('*');for(var m=0;m<tx.length;m++){if(!tx[m].children.length&&/موثق/.test(tx[m].textContent))tx[m].textContent='مشترٍ موثّق';}}}
function collect(){var out=[],seen={};var cards=document.querySelectorAll('.jm-review-widget .jm-review-item,.jdgm-rev-widg__reviews .jdgm-rev');for(var i=0;i<cards.length&&out.length<6;i++){var c=cards[i],r=null;var ls=c.querySelector('.jdgm-rev__rating');if(ls)r=parseInt(ls.getAttribute('data-score'),10);var ns=c.querySelector('.jm-star-rating[aria-label]');if(ns){var m=ns.getAttribute('aria-label').match(/^(\d)/);if(m)r=parseInt(m[1],10);}if(!r||r<4||rqNat(c)||rqWant(c))continue;var b=c.querySelector('.jdgm-rev__body,.jm-review-content__body');if(!b)continue;var t=b.textContent.replace(/\s+/g,' ').trim();if(t.length<18||t.length>170||!/[؀-ۿ]/.test(t)||seen[t])continue;seen[t]=1;var ne=c.querySelector('[data-sedr-name],.jdgm-rev__author,.jm-reviewer-info__name');var nm=ne?ne.textContent.trim():'';if(/^(anonymous|customer|anon|guest)\.?$/i.test(nm))nm='عميل سدر';out.push({r:r,t:t,n:nm});}return out;}
function snippet(){if(ONE||!document.querySelector('.product-info'))return;var bb=document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');if(!bb)return;var R=collect();if(!R.length)return;ONE=1;var anchor=(bb.nextElementSibling&&bb.nextElementSibling.getAttribute('data-block-type')==='liquid')?bb.nextElementSibling:bb;var badge=document.querySelector('.jdgm-prev-badge[data-number-of-reviews]');var N=badge?badge.getAttribute('data-number-of-reviews'):'';var box=document.createElement('div');box.className='sedr-snip';box.setAttribute('aria-label','من آراء العملاء');var chevR='<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 3l5 5-5 5"/></svg>',chevL='<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 3L5 8l5 5"/></svg>';var h='';for(var i=0;i<R.length;i++){h+='<div class="sedr-snip__slide'+(i?'':' is-on')+'"><div class="sedr-snip__top"><span class="sedr-snip__stars" aria-label="'+R[i].r+' من 5">'+stars(R[i].r)+'</span><span class="sedr-snip__name">'+esc(R[i].n)+'</span></div><p class="sedr-snip__text">'+esc(R[i].t)+'</p>'+(N?'<button type="button" class="sedr-snip__all">اقرأ جميع التقييمات ('+esc(N)+')</button>':'')+'</div>';}
if(R.length>1)h+='<button type="button" class="sedr-snip__btn sedr-snip__prev" aria-label="السابق">'+chevR+'</button><button type="button" class="sedr-snip__btn sedr-snip__next" aria-label="التالي">'+chevL+'</button>';box.innerHTML=h;anchor.parentNode.insertBefore(box,anchor.nextSibling);var idx=0,sl=box.querySelectorAll('.sedr-snip__slide');function go(d){sl[idx].classList.remove('is-on');idx=(idx+d+sl.length)%sl.length;sl[idx].classList.add('is-on');}var timer=R.length>1?setInterval(function(){if(!box.isConnected){clearInterval(timer);return;}if(document.hidden||(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches))return;var rect=box.getBoundingClientRect();if(rect.bottom>0&&rect.top<window.innerHeight)go(1);},7000):null;box.addEventListener('mouseenter',function(){clearInterval(timer);});box.addEventListener('click',function(e){var t=e.target.closest('button');if(!t)return;clearInterval(timer);if(t.classList.contains('sedr-snip__next'))go(1);else if(t.classList.contains('sedr-snip__prev'))go(-1);else{var w=document.querySelector('.jdgm-review-widget');if(w)w.scrollIntoView({behavior:'smooth',block:'start'});}});}
function cards(){var a=document.querySelectorAll('.product-card a.rating:not([data-s5])');for(var i=0;i<a.length;i++){var el=a[i];el.setAttribute('data-s5','1');var box=el.querySelector('.rating__stars');if(!box)continue;var m=(box.getAttribute('aria-label')||'').match(/(\d+(?:\.\d+)?)/);if(!m)continue;var x=parseFloat(m[1]),f=Math.floor(x),r=x-f,v=r>=.75?f+1:f,hf=r>=.25&&r<.75;var h='';for(var k=0;k<5;k++)h+=k===v&&hf?'<svg viewBox="0 0 15 15" width="13" height="13" class="half" aria-hidden="true"><g class="off">'+P+'</g><path class="on" fill="currentColor" d="'+(document.documentElement.dir==='rtl'?'M7.5 0L9.58587 5.2731L15 5.72949L10.875 9.44483L12.1353 15L7.5 12.0231Z':'M7.5 0L5.41414 5.2731L0 5.72949L4.125 9.44483L2.86475 15L7.5 12.0231Z')+'"/></svg>':'<svg viewBox="0 0 15 15" width="13" height="13" class="'+(k<v?'on':'off')+'" aria-hidden="true">'+P+'</svg>';var s=document.createElement('span');s.className='sedr-s5';s.innerHTML=h;box.appendChild(s);}}
var WSEL='.jm-review-collection-info,.jm-ai-disclaimer,.jm-store-summary-disclaimer__text,.jdgm-tab,.jdgm-tab-dropdown,.jm-product-variant-card p,.jdgm-translate-button,.jm-other-languages-section__heading,.jdgm-write-review-modal__checkbox-text,.jdgm-write-review-modal__gdpr-statement';function ww(s){return s.replace(/مراجعة مجهولة/g,'تقييم دون ذكر الاسم').replace(/مراجعات المنتج(?!ات)/g,'تقييمات المنتجات').replace(/المراجعات/g,'التقييمات').replace(/مراجعات/g,'تقييمات').replace(/المراجعة/g,'التقييم').replace(/مراجعت/g,'تقييم').replace(/مراجعة/g,'تقييم').replace(/تقييم ل(\s*)$/,'تقييم لـ$1');}function words(){var els=document.querySelectorAll(WSEL);for(var i=0;i<els.length;i++){var w=document.createTreeWalker(els[i],NodeFilter.SHOW_TEXT),n;while((n=w.nextNode())){var t=n.nodeValue;if(t.indexOf('مراجع')>-1){var v=ww(t);if(v!==t)n.nodeValue=v;}}}var a=document.querySelectorAll('[aria-label*="مراجع"]');for(var j=0;j<a.length;j++)a[j].setAttribute('aria-label',ww(a[j].getAttribute('aria-label')));}
// REV-18: وسم إفصاح «رونق» تحت التقييم الموثّق المكتوب منذ إطلاق البرنامج (22 أكتوبر 2026)، ما لم يكن عليه وسم المكافأة من Judge.me نفسه (rqNat: يُعرف بنصه، لأن قائمة وسوم Judge.me تعرض مصدر التقييم أيضًا، كالدعوة والمزوّد الآخر، ولا يميّز الوسمَ صنفٌ). يُعرف بالتاريخ وحده، ولا يُعرف هل كسب صاحبه النقاط فعلًا، فالنص احتمال. ولا يعمل إلا إن كانت صيغة التاريخ في Judge.me هي dd/mm/yyyy، لأن غيرها يُقرأ خطأً (03/11 في mm/dd يُقرأ 3 نوفمبر). وتُستثنى التقييمات ذوات الوسمين من شريط التقييمات بجانب زر الشراء (collect)، ويُضاف الوسم ويُصلح «مشترٍ موثّق» قبل الرسم التالي (immediate) حتى لا تنزاح البطاقات بعد ظهورها. والتنسيق مكتوب في العنصر نفسه لأن تنسيق Judge.me مقيّد بعناصره (Vue scoped) فلا يصل إلى عنصر نضيفه
var RQ=20261022,RQT={ar:'قد يكون صاحب هذا التقييم كسب به نقاطًا في برنامج المكافآت',en:'The reviewer may have earned loyalty points for this review'};
function rqWant(c){var f=window.jdgmSettings&&window.jdgmSettings.review_date_format;if(f&&f!=='dd/mm/yyyy')return false;var info=c.querySelector('.jm-reviewer-info');if(!info||!info.querySelector('.jm-verified-buyer-badge,.jm-verified-badge'))return false;var ts=info.querySelectorAll('.jm-text');for(var k=0;k<ts.length;k++){var m=ts[k].textContent.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);if(m)return +m[2]>=1&&+m[2]<=12&&+m[1]>=1&&+m[1]<=31&&+(m[3]+m[2]+m[1])>=RQ;}return false;}
function rqNat(c){var l=c.querySelectorAll('.jm-transparency-badge-list:not(.sedr-rq)'),s=window.jdgmSettings&&window.jdgmSettings.transparency_badges_earned_reward_text;for(var i=0;i<l.length;i++){var x=l[i].textContent;if((s&&x.indexOf(s)>-1)||/reward|مكافأة/i.test(x))return true;}return false;}
function rawnaq(){var it=document.querySelectorAll('.jm-review-item__content');for(var i=0;i<it.length;i++){var c=it[i],own=c.querySelector('.sedr-rq'),want=!rqNat(c)&&rqWant(c);if(want&&!own){var d=document.createElement('div');d.className='jm-stack jm-stack--space-200 jm-transparency-badge-list sedr-rq';d.setAttribute('style','margin-block-start: var(--jm-space-400, 1rem);');var t=document.createElement('div');t.className='jm-text';t.setAttribute('style','font-size: var(--jm-body-sm-size, .875em); font-weight: var(--jm-body-sm-weight-default, 400); color: var(--jm-review-widget-lighter-text-color, #7B7B7B);');t.textContent=RQT[(document.documentElement.lang||'').toLowerCase().indexOf('en')===0?'en':'ar'];d.appendChild(t);c.appendChild(d);}else if(!want&&own)own.parentNode.removeChild(own);}}
function run(){tr();counts();snippet();cards();words();}window.sedrReviewsObserve(run);window.sedrReviewsObserve(vbadge,true);window.sedrReviewsObserve(rawnaq,true);vbadge();rawnaq();run();})();
;
/* product page: histogram rows filter the reviews, like the store summary */
(function(){
  if(!document.getElementById('sedr-hist-filter')){var st=document.createElement('style');st.id='sedr-hist-filter';st.textContent='.sedr-hist[data-sedr-f][data-sedr-f]{gap:3px}.sedr-hist__row[data-sedr-r]{padding:3px 8px;margin-inline:-8px;border-radius:8px}.sedr-hist__row[role=button]{cursor:pointer;-webkit-tap-highlight-color:transparent;-webkit-user-select:none;user-select:none}.sedr-hist__row[role=button]:focus-visible{outline:2px solid #E0BF93;outline-offset:0}@media (hover:hover) and (pointer:fine){.sedr-hist__row[role=button]:hover{background:rgba(244,243,240,.07);color:#F4F3F0}}.sedr-hist__row[aria-pressed=true]{background:rgba(224,191,147,.16);color:#F4F3F0}.sedr-hist__row[aria-pressed=true] .sedr-hist__label,.sedr-hist__row[aria-pressed=true] .sedr-hist__count{color:#E0BF93}.sedr-hist__row[aria-disabled=true]{opacity:.6}';(document.head||document.documentElement).appendChild(st);}
  var SEL='.sedr-hist__row';
  function rate(row){return parseInt((row.querySelector('.sedr-hist__label')||row).textContent,10)||0;}
  function num(row){return parseInt(((row.querySelector('.sedr-hist__count')||{}).textContent||'').replace(/[^0-9]/g,''),10)||0;}
  function words(r){return r===1?'نجمة واحدة':r===2?'نجمتين':r+' نجوم';}
  function current(w){var i=w&&w.querySelector('.jm-filter-panel input[name="rating-filter"]:checked');return i?i.value:'';}
  function sync(){
    var boxes=document.querySelectorAll('.sedr-hist');
    for(var b=0;b<boxes.length;b++){
      var box=boxes[b],cur=current(box.closest('.jm-review-widget')),rows=box.querySelectorAll(SEL);
      for(var i=0;i<rows.length;i++){
        var row=rows[i];
        if(!row.hasAttribute('data-sedr-r')){
          var r=rate(row),n=num(row);
          row.setAttribute('data-sedr-r',r);
          if(r&&n){row.setAttribute('role','button');row.setAttribute('tabindex','0');row.setAttribute('aria-label','عرض تقييمات '+words(r)+' ('+n+')');}
          else row.setAttribute('aria-disabled','true');
        }
        if(row.getAttribute('role')==='button'){
          var on=String(row.getAttribute('data-sedr-r')===cur);
          if(row.getAttribute('aria-pressed')!==on)row.setAttribute('aria-pressed',on);
        }
        /* replaces .sedr-hist:has(>.sedr-hist__row[data-sedr-r]) */
        if(row.parentNode===box&&!box.hasAttribute('data-sedr-f'))box.setAttribute('data-sedr-f','1');
      }
    }
  }
  function later(){setTimeout(sync,80);setTimeout(sync,400);}
  function tick(f){if(document.hidden)setTimeout(f,40);else requestAnimationFrame(f);}
  function pick(row){
    var w=row.closest('.jm-review-widget');if(!w)return;
    var r=row.getAttribute('data-sedr-r'),tries=0,y=null,opened=false;
    /* questions tab open: go back to the reviews tab first */
    if(w.querySelector('[role=tab][aria-selected=true][id$="questions_answers"]')){var rt=w.querySelector('[role=tab]:not([id$="questions_answers"])');if(rt)rt.click();}
    (function go(){
      var p=w.querySelector('.jm-filter-panel');
      if(!p){
        if(!opened){var btn=w.querySelector('.jm-custom-answer-filter');if(btn){opened=true;y=row.getBoundingClientRect().top;btn.click();}}
        if(++tries<120)tick(go);
        return;
      }
      /* the panel opens above the rows: keep the tapped row where it was */
      if(y!==null&&row.isConnected){var d=row.getBoundingClientRect().top-y;if(Math.abs(d)>1)window.scrollBy(0,d);}
      var inp=p.querySelector('input[name="rating-filter"][value="'+r+'"]');if(!inp)return;
      if(inp.checked){var c=p.querySelector('.jm-filter-panel__clear-btn');if(c)c.click();}
      else(inp.closest('label')||inp).click();
      sync();later();
    })();
  }
  document.addEventListener('click',function(e){
    var t=e.target;if(!t||!t.closest)return;
    var row=t.closest(SEL+'[role=button]');
    if(row){pick(row);return;}
    if(t.closest('.jm-filter-panel,.jm-custom-answer-filter'))later();
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Enter'&&e.key!==' ')return;
    var row=e.target&&e.target.closest&&e.target.closest(SEL+'[role=button]');
    if(row){e.preventDefault();pick(row);}
  });
  window.sedrReviewsObserve(sync);
  sync();
})();
/* names: keep Judge.me's short format (e.g. محمد ع.) instead of trimming to the first name */
(function(){
  var NS='.jm-reviewer-info__name,.jdgm-rev__author,[class*="carousel-item__reviewer-name"],.jdgm-reviewer-name';
  var ANON=/^(anonymous|customer|anon|guest)\.?$/i,LABEL='عميل سدر';
  function mark(){
    var els=document.querySelectorAll(NS);
    for(var i=0;i<els.length;i++){
      var el=els[i];if(el.children.length)continue;
      var t=(el.textContent||'').trim();if(!t)continue;
      if(ANON.test(t)){if(el.classList.contains('jdgm-reviewer-name')){el.textContent=LABEL;el.setAttribute('data-sedr-name',LABEL);}continue;}
      var c=t.replace(/\s+\.+(?=[^\s.])/g,' ').replace(/\s{2,}/g,' ').replace(/^(\S+\s+[^\s.]\.)(?:[^\s.]\.)+$/,'$1');
      if(c!==t)el.textContent=c;
      if(el.getAttribute('data-sedr-name')!==c)el.setAttribute('data-sedr-name',c);
    }
  }
  window.sedrReviewsObserve(mark);
  mark();
})();
/* Q&A: keep tabs + filter panel together, empty state for the questions tab */
(function(){
  if(!document.getElementById('sedr-qa')){var st=document.createElement('style');st.id='sedr-qa';st.textContent='.jm-review-widget__header[data-sedr-h~=hist]>.jdgm-tabs{grid-column:1/-1;min-width:0;margin-top:8px}.jm-review-widget__header[data-sedr-h~=hist][data-sedr-h~=tabs]>[data-sedr-fp]{grid-area:auto;grid-column:1/-1}@media (max-width:989px){.jm-review-widget__header[data-sedr-h~=hist][data-sedr-h~=tabs][data-sedr-h~=fp]{grid-template-areas:"top" "hist" "media" "ai"}}@media (min-width:990px){.jm-review-widget__header[data-sedr-h~=hist][data-sedr-h~=tabs][data-sedr-h~=fp]{grid-template-rows:auto 1fr auto;grid-template-areas:"top ai" "hist ai" "media media"}.jm-review-widget__header[data-sedr-h~=hist][data-sedr-h~=tabs][data-sedr-h~=fp]:not([data-sedr-h~=media]){grid-template-rows:auto 1fr;grid-template-areas:"top ai" "hist ai"}.jm-review-widget__header[data-sedr-h~=hist][data-sedr-h~=tabs][data-sedr-h~=fp]:not([data-sedr-h~=ai]){grid-template-rows:auto auto;grid-template-areas:"top hist" "media media"}.jm-review-widget__header[data-sedr-h~=hist][data-sedr-h~=tabs][data-sedr-h~=fp]:not([data-sedr-h~=ai]):not([data-sedr-h~=media]){grid-template-rows:auto;grid-template-areas:"top hist"}}.jm-review-widget[data-sedr-tab=qa][data-sedr-tab][data-sedr-tab] .sedr-ai{display:none}.jm-review-widget[data-sedr-rev0="1"] .jm-review-widget-minimal-header__filters{display:none}.jm-review-widget[data-sedr-qa="0"][data-sedr-hist] [role=tabpanel][id$="questions_answers"]:empty::before{content:"لم يُطرح أي سؤال عن هذا المنتج بعد. يمكنك إرسال سؤالك من زر «اطرح سؤالاً».";display:block;margin-top:24px;padding:26px 22px;background:#F8F7F5;border:1px solid #E9E7E3;border-radius:16px;color:#4A3B31;text-align:center;font-size:15px;line-height:1.8}';(document.head||document.documentElement).appendChild(st);}
  /* state attributes replace :has() in the rules above: :has() made every style recalculation on the page slow */
  function set(el,name,v){if((el.getAttribute(name)||'')!==v){if(v)el.setAttribute(name,v);else el.removeAttribute(name);}}
  function child(p,cls){for(var c=p.firstElementChild;c;c=c.nextElementSibling)if(c.classList.contains(cls))return true;return false;}
  function layout(){
    var hs=document.querySelectorAll('.jm-review-widget__header');
    for(var i=0;i<hs.length;i++){
      var h=hs[i],v=[],fp=false;
      for(var c=h.firstElementChild;c;c=c.nextElementSibling){var f=child(c,'jm-filter-panel');set(c,'data-sedr-fp',f?'1':'');if(f)fp=true;}
      if(h.querySelector('.sedr-hist'))v.push('hist');
      if(child(h,'jdgm-tabs'))v.push('tabs');
      if(fp)v.push('fp');
      if(child(h,'jm-media-preview'))v.push('media');
      if(child(h,'jm-ai-insights')&&!/^ar/i.test(document.documentElement.lang||''))v.push('ai');
      set(h,'data-sedr-h',v.join(' '));
    }
    var ws=document.querySelectorAll('.jm-review-widget');
    for(var j=0;j<ws.length;j++){
      set(ws[j],'data-sedr-hist',ws[j].querySelector('.sedr-hist')?'1':'');
      set(ws[j],'data-sedr-tab',ws[j].querySelector('[role=tab][id$="questions_answers"][aria-selected=true]')?'qa':'');
    }
  }
  function zero(el){var m=(el.textContent||'').match(/\(\s*([0-9٠-٩]+)\s*\)/);return !!(m&&/^[0٠]+$/.test(m[1]));}
  function mark(){
    var t=document.querySelectorAll('.jm-review-widget [role=tab][id$="questions_answers"]');
    for(var i=0;i<t.length;i++){
      var w=t[i].closest('.jm-review-widget');if(!w)continue;
      var v=zero(t[i])?'0':'';
      if((w.getAttribute('data-sedr-qa')||'')!==v){if(v)w.setAttribute('data-sedr-qa',v);else w.removeAttribute('data-sedr-qa');}
      /* no reviews yet: hide the filter and sort buttons next to the tabs */
      var rt=w.querySelector('[role=tab]:not([id$="questions_answers"])'),z=rt&&zero(rt)?'1':'';
      if((w.getAttribute('data-sedr-rev0')||'')!==z){if(z)w.setAttribute('data-sedr-rev0',z);else w.removeAttribute('data-sedr-rev0');}
    }
    var n=document.querySelectorAll('.jdgm-ask-question-form input[name="name"][placeholder*="تقييمك"]');
    for(var j=0;j<n.length;j++)n[j].setAttribute('placeholder',n[j].getAttribute('placeholder').replace('تقييمك','سؤالك'));
    var l=document.querySelectorAll('.jm-review-collection-link[aria-label*="opens in a new tab"]');
    for(var k=0;k<l.length;k++)l[k].setAttribute('aria-label',l[k].getAttribute('aria-label').replace(/,?\s*opens in a new tab/i,'، يُفتح في نافذة جديدة'));
    var x=document.querySelectorAll('button[aria-label="Close modal"]');
    for(var y=0;y<x.length;y++)x[y].setAttribute('aria-label','إغلاق');
  }
  /* Arabic pages: the app leaves the read-more button of an answer in English */
  var AR=/^ar/i.test(document.documentElement.lang||'');
  function more(){
    if(!AR)return;
    var b=document.querySelectorAll('.jdgm-reply-item__read-more');
    for(var i=0;i<b.length;i++){
      var o=b[i].getAttribute('aria-expanded')==='true',tx=o?'عرض أقل':'عرض المزيد',al=o?'طيّ الإجابة':'عرض الإجابة كاملة',n=b[i].firstChild;
      if(n&&n.nodeType===3&&b[i].childNodes.length===1&&n.nodeValue.trim()!==tx)n.nodeValue=tx;
      if(b[i].getAttribute('aria-label')!==al)b[i].setAttribute('aria-label',al);
    }
  }
  window.sedrReviewsObserve(mark);
  mark();
  /* Arabic pages: counted noun, the filter label, and the screen-reader labels the app leaves in English */
  var LBL=[[/^([\d.]+) out of (\d+) stars?$/i,'$1 من $2 نجوم'],[/^Go to item (\d+)$/i,'عرض الصورة $1'],[/^Thumbnails for (\d+) items?$/i,'صور العملاء ($1)'],[/^Scroll thumbnails right$/i,'تمرير الصور إلى اليمين'],[/^Scroll thumbnails left$/i,'تمرير الصور إلى اليسار'],[/^Loading thumbnail$/i,'جارٍ تحميل الصورة'],[/^AI-powered$/i,'مُعدّ بالذكاء الاصطناعي'],[/^Tabs$/i,'الأقسام'],[/^View review image$/i,'عرض صورة التقييم'],[/^Pagination Navigation$/i,'صفحات التقييمات'],[/^Go to previous page$/i,'الصفحة السابقة'],[/^Go to next page$/i,'الصفحة التالية'],[/^Go to page (\d+)$/i,'الصفحة $1'],[/^(\d+)% \(([\d,]+)\) reviews? with (\d) star rating$/i,'$1% ($2) من التقييمات بتقدير $3 من 5'],[/^View (.+) product page$/i,'عرض صفحة المنتج: $1'],[/^فلاتر$/,'تصفية']];
  function noun(s){var n=parseInt(s.replace(/[^\d]/g,''),10),m=n%100;if(!n)return '';return n===1?'تقييم واحد':n===2?'تقييمان':m>=3&&m<=10?s+' تقييمات':m>=11?s+' تقييمًا':s+' تقييم';}
  function ar(){
    if(!AR)return;
    var e=document.querySelectorAll('.jm-review-widget [aria-label],.jdgm-modal [aria-label]'),i,j,a,r;
    for(i=0;i<e.length;i++){
      a=e[i].getAttribute('aria-label');
      for(j=0;j<LBL.length;j++)if(LBL[j][0].test(a)){r=a.replace(LBL[j][0],LBL[j][1]);if(r!==a)e[i].setAttribute('aria-label',r);break;}
    }
    var f=document.querySelectorAll('.jm-average-rating-display p.jm-text,.jm-custom-answer-filter,.jm-filter-panel,.jdgm-prev-badge__text'),w,n,m;
    for(i=0;i<f.length;i++){
      w=document.createTreeWalker(f[i],4,null);
      while((n=w.nextNode())){
        a=n.nodeValue;
        if(a.trim()==='فلاتر')n.nodeValue='تصفية';
        else if((m=a.match(/^\s*([\d,٬]+)\s*تقييمات\s*$/))&&(r=noun(m[1]))&&r!==a)n.nodeValue=r;
      }
    }
  }
  window.sedrReviewsObserve(more,true);
  more();
  window.sedrReviewsObserve(ar,true);
  ar();
  window.sedrReviewsObserve(layout,true);
  /* an older shared observer has no immediate jobs: watch here instead */
  if(!window.sedrReviewsObserve.immediate)new MutationObserver(layout).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-selected']});
  layout();
})();

})();

/* Reserve a measured Reviews body only while returning from the questions tab. */
(function () {
  if (window.sedrReviewsPanelSpaceLoaded || !window.sedrReviewsObserve) return;
  window.sedrReviewsPanelSpaceLoaded = true;
  var states = [], poll = null;
  var TAB = '[role="tab"][id$="product_reviews"]';
  var QA = '[role="tab"][id$="questions_answers"]';
  var BODY = '.jm-review-widget__body[role="tabpanel"]';
  function selected(widget, selector) {
    var tab = widget.querySelector(selector);
    return !!(tab && tab.getAttribute('aria-selected') === 'true');
  }
  function stateFor(widget) {
    for (var i = 0; i < states.length; i++) if (states[i].widget === widget) return states[i];
    var state = {widget: widget, body: null, list: null, width: 0, height: 0, reserved: null, timeout: null};
    states.push(state);
    return state;
  }
  function loading(body) {
    return body.classList.contains('jm-loading-overlay--active') || !!body.querySelector('.jm-loading-overlay__shimmer');
  }
  function realList(body) {
    var list = body.querySelector('.jdgm-review-list');
    return list && list.querySelector('.jm-review-item') ? list : null;
  }
  function clear(state, forget) {
    if (state.timeout !== null) clearTimeout(state.timeout);
    state.timeout = null;
    if (state.reserved) {
      state.reserved.removeAttribute('data-sedr-review-space');
      state.reserved.style.removeProperty('--sedr-review-space');
    }
    state.reserved = null;
    if (forget) { state.body = null; state.list = null; state.width = 0; state.height = 0; }
  }
  function remember(state, body) {
    if (state.reserved || !selected(state.widget, TAB) || !body || loading(body)) return;
    var list = realList(body);
    if (!list) return;
    var rect = body.getBoundingClientRect(), style = getComputedStyle(body), height = rect.height;
    if (style.boxSizing !== 'border-box') {
      height -= (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0) +
        (parseFloat(style.borderTopWidth) || 0) + (parseFloat(style.borderBottomWidth) || 0);
    }
    if (rect.width <= 0 || height <= 0) return;
    state.body = body; state.list = list; state.width = rect.width; state.height = height;
  }
  function zeroReviews(widget) {
    var tab = widget.querySelector(TAB), match = tab && (tab.textContent || '').match(/\(\s*([0-9٠-٩]+)\s*\)/);
    return !!(match && /^[0٠]+$/.test(match[1]));
  }
  function schedulePoll() {
    if (poll !== null) return;
    for (var i = 0; i < states.length; i++) if (states[i].reserved) {
      poll = setTimeout(function () { poll = null; sync(); }, 100);
      return;
    }
  }
  function sync() {
    var widgets = document.querySelectorAll('.jm-review-widget');
    for (var i = 0; i < widgets.length; i++) if (widgets[i].querySelector(TAB) && widgets[i].querySelector(QA)) stateFor(widgets[i]);
    for (var j = states.length - 1; j >= 0; j--) {
      var state = states[j], widget = state.widget;
      if (!widget.isConnected) { clear(state, true); states.splice(j, 1); continue; }
      var body = widget.querySelector(BODY);
      if (state.reserved) {
        if (body !== state.reserved || !selected(widget, TAB) || Math.abs(body.getBoundingClientRect().width - state.width) > 1) clear(state, true);
        else if (!loading(body)) {
          var list = realList(body);
          /* Stale Q&A can remove loading while installing an empty state. A fresh real list is required. */
          if ((list && list !== state.list) || zeroReviews(widget)) clear(state, false);
        }
      }
      remember(state, body);
    }
    schedulePoll();
  }
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest && event.target;
    if (!target) return;
    var widget = target.closest('.jm-review-widget');
    if (!widget || !widget.querySelector(TAB) || !widget.querySelector(QA)) return;
    var state = stateFor(widget), tab = target.closest('[role="tab"]'), body = widget.querySelector(BODY);
    if (tab) {
      if (!tab.matches(TAB)) { clear(state, false); remember(state, body); return; }
      if (!selected(widget, QA)) return;
      clear(state, false);
      if (!body || body !== state.body || !state.height || zeroReviews(widget) || Math.abs(body.getBoundingClientRect().width - state.width) > 1) return;
      state.reserved = body;
      body.style.setProperty('--sedr-review-space', state.height + 'px');
      body.setAttribute('data-sedr-review-space', '1');
      /* Empty/error states stay native and visible; the safeguard bounds any retained whitespace. */
      state.timeout = setTimeout(function () { clear(state, false); sync(); }, 10000);
      schedulePoll();
    } else if (target.closest('.jm-filter-panel,.jm-custom-answer-filter,.jm-pagination-controls,.sedr-hist__row,.jdgm-sort-dropdown,.jm-sort-menu,.jm-sort-filter')) {
      clear(state, true);
    }
  }, true);
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('.jdgm-sort-dropdown,.jm-sort-filter__select')) return;
    var widget = target.closest('.jm-review-widget');
    if (widget && widget.querySelector(TAB) && widget.querySelector(QA)) clear(stateFor(widget), true);
  }, true);
  window.addEventListener('resize', function () {
    for (var i = 0; i < states.length; i++) clear(states[i], true);
  });
  window.sedrReviewsObserve(sync);
  sync();
})();
/* Sedr reviews: show the first reviews, and one button opens the rest with the other-languages section. */
(function () {
  var open = false;
  var en = /^en/i.test(document.documentElement.lang || '');
  var arrow = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6l5 5 5-5"/></svg>';
  function shown() { return window.matchMedia && window.matchMedia('(min-width: 1400px)').matches ? 4 : 3; }
  function sync() {
    var widgets = document.querySelectorAll('.jm-review-widget');
    for (var i = 0; i < widgets.length; i++) {
      var w = widgets[i];
      var body = w.querySelector('.jm-review-widget__body');
      var list = body && body.querySelector('.jdgm-review-list');
      if (!list) continue;
      var more = list.querySelectorAll(':scope > .jm-review-item').length > shown() ||
        w.querySelector('.jm-pagination-controls') ||
        w.querySelector('.jm-other-languages-section .jm-review-item');
      var state = open || !more ? 'open' : 'closed';
      if (w.getAttribute('data-sedr-fold') !== state) w.setAttribute('data-sedr-fold', state);
      if (state === 'open' || body.querySelector(':scope > .sedr-fold-btn')) continue;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sedr-fold-btn';
      b.setAttribute('aria-expanded', 'false');
      b.innerHTML = '<span></span>' + arrow;
      b.firstChild.textContent = en ? 'Show more reviews' : 'عرض المزيد من التقييمات';
      b.addEventListener('click', function () {
        var l = this.parentNode && this.parentNode.querySelector('.jdgm-review-list > .jm-review-item:nth-child(' + (shown() + 1) + ')');
        open = true;
        sync();
        if (l) { l.setAttribute('tabindex', '-1'); l.focus({ preventScroll: true }); }
      });
      body.appendChild(b);
    }
  }
  window.sedrReviewsObserve(sync);
  sync();
})();
;
/* REV-18، REV-20: زر الصفحة الأخيرة في نموذج التقييم (الأسئلة إن وُجدت، وإلا الصور) يُرسل التقييم، فنصه «إرسال التقييم» لا «التالي» */
(function () {
  if (window.sedrReviewsSubmitLabel) return;
  window.sedrReviewsSubmitLabel = true;
  var en = /^en/i.test(document.documentElement.lang || '');
  function sync() {
    var b = document.querySelector('.jdgm-write-review-modal__nav-btn-next');
    if (!b) return;
    if (!b.hasAttribute('data-sedr-label')) {
      b.setAttribute('data-sedr-label', b.textContent);
      b.setAttribute('data-sedr-aria', b.getAttribute('aria-label') || '');
    }
    // The last page is whichever comes before the thanks: the questions when the product has them, else the media.
    var pages = [].slice.call(document.querySelectorAll('.jdgm-write-review-modal__page')).filter(function (p) {
      if (/--thank-you|--review-form-intro/.test(p.className)) return false;
      return !/--custom-questions/.test(p.className) || !!p.querySelector('.jdgm-cf');
    });
    var cur = document.querySelector('.jdgm-write-review-modal__page.current-page');
    var last = !!cur && cur === pages[pages.length - 1];
    var text = last ? (en ? 'Submit review' : 'إرسال التقييم') : b.getAttribute('data-sedr-label');
    var aria = last ? text : b.getAttribute('data-sedr-aria');
    if (b.textContent !== text) b.textContent = text;
    if ((b.getAttribute('aria-label') || '') !== aria) b.setAttribute('aria-label', aria);
  }
  function later() { setTimeout(sync, 0); setTimeout(sync, 400); }
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.jdgm-write-review-modal, .jm-action-buttons__button')) later();
  });
  document.addEventListener('keyup', function (event) {
    if (event.target.closest && event.target.closest('.jdgm-write-review-modal')) later();
  });
})();

/* All Reviews page: a "go to page" box under the pagination, hidden with it until "show more" opens the list, and whenever the pagination is gone (e.g. a filter with one page or none). Uses the widget's own page-change handler. */
(function () {
  if (window.sedrPageJumpLoaded || !window.sedrReviewsObserve) return;
  window.sedrPageJumpLoaded = true;
  var en = /^en/i.test(document.documentElement.lang || '');
  var T = en ? { label: 'Go to page', go: 'Go' } : { label: 'الانتقال إلى الصفحة', go: 'انتقال' };
  if (!document.getElementById('sedr-page-jump-css')) {
    var st = document.createElement('style');
    st.id = 'sedr-page-jump-css';
    st.textContent = '.sedr-page-jump{display:none;align-items:center;justify-content:center;gap:8px;margin-top:12px;font-size:14px}'
      + '.sedr-page-jump input{width:4.5em;height:36px;padding:0 8px;border:1px solid currentColor;border-radius:999px;background:transparent;color:inherit;font:inherit;text-align:center;-moz-appearance:textfield}'
      + '.sedr-page-jump input::-webkit-inner-spin-button,.sedr-page-jump input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}'
      + '.sedr-page-jump button{height:36px;padding:0 16px;border:1px solid currentColor;border-radius:999px;background:transparent;color:inherit;font:inherit;cursor:pointer}'
      + '.jm-pagination-controls+.sedr-page-jump{display:flex}'
      + '.jm-review-widget[data-sedr-fold="closed"] .sedr-page-jump{display:none!important}';
    (document.head || document.documentElement).appendChild(st);
  }
  function pager(widget) {
    var found = null, seen = {};
    function walkV(v) {
      if (!v || found) return;
      if (v.component) walkC(v.component);
      if (Array.isArray(v.children)) for (var i = 0; i < v.children.length && !found; i++) walkV(v.children[i]);
      if (v.suspense && v.suspense.activeBranch) walkV(v.suspense.activeBranch);
    }
    function walkC(c) {
      if (seen[c.uid]) return;
      seen[c.uid] = true;
      var t = c.type || {};
      if ((t.name || t.__name) === 'PaginationControls') { found = c; return; }
      walkV(c.subTree);
    }
    walkV(widget._vnode);
    return found;
  }
  function build(widget) {
    var form = document.createElement('form');
    form.className = 'sedr-page-jump';
    form.setAttribute('novalidate', '');
    form.innerHTML = '<label></label><input type="number" inputmode="numeric" min="1" step="1"><button type="submit"></button>';
    var id = 'sedr-page-jump-' + Math.random().toString(36).slice(2, 8);
    var label = form.querySelector('label'), input = form.querySelector('input'), button = form.querySelector('button');
    label.textContent = T.label;
    label.htmlFor = id;
    input.id = id;
    button.textContent = T.go;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var pc = pager(widget);
      var n = parseInt(input.value, 10);
      if (!pc || !pc.vnode.props || !pc.vnode.props.onPageChange || !n) return;
      var total = pc.props.totalPages || 1;
      n = Math.max(1, Math.min(total, n));
      input.value = '';
      if (n !== pc.props.currentPage) pc.vnode.props.onPageChange(n);
    });
    return form;
  }
  function place() {
    var widgets = document.querySelectorAll('.jdgm-all-reviews-widget-v2025');
    for (var i = 0; i < widgets.length; i++) {
      var w = widgets[i], nav = w.querySelector('.jm-pagination-controls');
      var form = w.querySelector('.sedr-page-jump');
      if (!nav) continue;
      if (!form) form = build(w);
      if (nav.nextElementSibling !== form) nav.parentNode.insertBefore(form, nav.nextSibling);
      var pc = pager(w);
      if (pc) {
        var input = form.querySelector('input'), max = String(pc.props.totalPages || '');
        if (input.max !== max) input.max = max;
        var ph = pc.props.currentPage + ' / ' + max;
        if (input.placeholder !== ph) input.placeholder = ph;
      }
    }
  }
  window.sedrReviewsObserve(place, true);
  place();
})();
